import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.tsx';
import LoadingSpinner from '../common/LoadingSpinner.tsx';

interface PromoterRouteProps {
  children: React.ReactNode;
}

const PromoterRoute: React.FC<PromoterRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.role !== 'PROMOTER') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PromoterRoute; 